import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import style from './style.scss';//NOSONAR

let actions = [];
let elements = [];

const Accordion = (props) =>{
    const [current, setCurrent] = useState(props.default || props.default === 0 ? props.default : -1);
    const [showNumber, setShowNumber] = useState(props.withQty);
    const [ShowComponent,setShowComponent] = useState(props.withComponent);

    useEffect(() => {
        if(!props.withQty){
            setShowNumber(true);
            setShowComponent(true);
        }else{
            setShowNumber(false);
            setShowComponent(false);
        }
        actions.push(PubSub.register('change_item_accordion', accordionItem));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];

        }
    }, []);

    const accordionItem = (payload) => {
        const index = payload.value.item;
            
        changeItem(index);
            
        if(index){
            setTimeout(()=>{
                if(elements[index]){
                    const element = elements[index].current;
                    const headerHeight = document.querySelector('.new-header').offsetHeight;
            
                    const elementTop = element.getBoundingClientRect().top
        
                    window.scrollTo({
                        left: 0,
                        top:elementTop-headerHeight-10,
                        behavior: 'smooth'
                    });
                }
            }, 1000);
        }
        
    }

    const changeItem = (item) => {
        if(item >= 0){
            setCurrent(item);
        
        }
    }

    const click = (index) => {

        index = index !== current ? index : -1;

        setCurrent(index);

        PubSub.dispatch('select_item_accordion', {
            item: index
        });
    }

    const content = props.content || [];

    return (
        <ul className="accordion-list">
            {content.map((item, i) =>{
                elements[i] = useRef();
                return <li ref={elements[i]} className={'accordion-item ' + (current === i ? 'active' : '')} key={i}>
                    <button className="accordion-button" onClick={() => click(i)}>
                        {(showNumber) ?
                            <span className="accordion-title">
                                <span className="accordion-number">{(i + 1) + '.'}</span>
                                <span dangerouslySetInnerHTML={{ __html: item.title }}></span>
                            </span> :
                            <span className="accordion-title">
                                <span className={'accordion-under-line ' + (current === i ? 'active' : '')}>{item.title}</span>
                                <span className="accordion-quantity">{item.quantity}</span>
                            </span>}
                        <i className="accordion-icon"></i>
                    </button>
                    {(ShowComponent) ?
                        <div className="accordion-mask">
                            <div className="accordion-content" dangerouslySetInnerHTML={{ __html: item.content }} id={"generales_" + (i + 1)}></div>
                        </div>
                        :
                        <div className="accordion-mask">
                            <div>{item.content}</div>
                        </div>}
                </li>}
            )}
        </ul>
    )

}

Accordion.propTypes = {
    content: PropTypes.array,
    default: PropTypes.number,
    withQty: PropTypes.bool,
    withComponent: PropTypes.bool
}
export default Accordion;
